import { Link } from "react-router-dom";
import { MiniChart } from "react-ts-tradingview-widgets";

import { Container } from "../Container";

const markets = [
  {
    name: "Stocks",
    description:
      "Shares in the world's leading companies across major global exchanges.",
    href: "/stocks",
    symbol: "NASDAQ:AAPL",
  },
  {
    name: "Crypto",
    description:
      "Bitcoin, Ethereum and other leading digital assets, around the clock.",
    href: "/crypto",
    symbol: "BITSTAMP:BTCUSD",
  },
  {
    name: "Forex",
    description:
      "Major and minor currency pairs in the world's most liquid market.",
    href: "/forex",
    symbol: "FX_IDC:EURUSD",
  },
];

export function MarketsOne() {
  return (
    <section
      id="markets"
      aria-labelledby="markets-title"
      className="bg-[#0c0f19] py-24"
    >
      <Container>
        <div className="max-w-2xl lg:max-w-xl">
          <h2
            id="markets-title"
            className="text-3xl font-bold tracking-tight text-white sm:text-4xl"
          >
            One account, every major market
          </h2>
          <p className="mt-6 text-lg leading-8 text-[#CECFD1]">
            Diversify across asset classes without switching platforms.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 sm:mt-20 lg:grid-cols-3">
          {markets.map((market) => (
            <div
              key={market.name}
              className="flex flex-col border-l border-white/10 pl-6"
            >
              <h3 className="text-lg font-semibold text-white">
                {market.name}
              </h3>
              <p className="mt-2 text-[16px] leading-7 text-[#CECFD1]">
                {market.description}
              </p>
              <div className="pointer-events-none -ml-2 mt-6 h-[160px]">
                <MiniChart
                  symbol={market.symbol}
                  colorTheme="dark"
                  width="100%"
                  height={160}
                  isTransparent
                  trendLineColor="#0C6CF2"
                  underLineColor="rgba(12, 108, 242, 0.12)"
                  underLineBottomColor="rgba(12, 108, 242, 0)"
                />
              </div>
              <Link
                to={market.href}
                className="mt-6 text-sm font-semibold text-white transition-colors hover:text-blue-500"
              >
                Explore {market.name.toLowerCase()}{" "}
                <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
